// Testing accounts that should not show up on the stats page of surveysaurus
export const excludedEmailDomains = ['nexient.com', 'swingtherapeutics.com','reactfmtest'];
export const excludedEmails = ['tempoact3nui@gmail.com', 'sreactfm@gmail.com','reactfmtest', 'swingfm397@gmail.com', '3temporfm@gmail.com', 'tempo3rfm@gmail.com', 'savannahhamilton415@gmail.com','swing004tester3@gmail.com'];

export const isExcludedEmail = (email: string): boolean => {
  return excludedEmails.includes(email) || excludedEmailDomains.some(domain => email.includes(domain))
}
